import { useEffect } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { requireActiveSubscription } from '@/lib/middleware'
import { FormsList } from '@/features/forms'

export const Route = createFileRoute('/_authenticated/_organization/forms/')({
  beforeLoad: async () => requireActiveSubscription(),
  component: FormsPage,
})

function FormsPage() {
  const navigate = useNavigate()
  const { data: activeOrganization, isPending: isLoadingOrganization } =
    authClient.useActiveOrganization()

  useEffect(() => {
    if (!isLoadingOrganization && !activeOrganization) {
      navigate({
        to: '/errors/$error',
        params: { error: 'forbidden' },
        state: {
          message:
            'No organization found. Please create an organization first and wait for approval.',
        } as any,
        replace: true,
      })
    }
  }, [isLoadingOrganization, activeOrganization, navigate])

  if (!activeOrganization) {
    return null
  }

  return (
    <FormsList
      organizationId={activeOrganization.id}
      onEditForm={(formId) => {
        navigate({
          to: `/forms/${formId}/edit` as any,
        })
      }}
      onPreviewForm={(formId) => {
        navigate({
          to: `/forms/${formId}/preview` as any,
        })
      }}
      onViewSubmissions={(formId) => {
        navigate({
          to: `/forms/${formId}/submissions` as any,
        })
      }}
    />
  )
}
